import React, { useState } from 'react';
import {
  Box,
  Container,
  makeStyles,
  Card, 
  Button,
  Typography,
  TextField,
  Divider,
  Snackbar,
  RadioGroup,
  Radio,
  FormLabel,
  FormControl,
  FormControlLabel,
} from '@material-ui/core';
import moment from 'moment';
import * as admin from 'firebase-admin';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { ptBR } from "date-fns/locale";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useAuth } from '../../../context/authContext';
import { Creators } from '../../../store/pmp/actions';
import Page from '../../../../src/components/Page';
import Alert from '../../../../src/components/Alert';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { FormContainer, NumericContainer, CategorieContainer, Spacing, TopSpacing, ButtonContainer } from './styles';
import { toUpper } from 'lodash';

admin.initializeApp();
const useStyles = makeStyles((theme, rest) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  card: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
  },
  formControl: {
    marginTop: 2,
    minWidth: 300,
  },
}));

const AddUserView = () => {
  const { currentUser } = useAuth();

  const officeId = sessionStorage.getItem('office-id');
  const dispatch = useDispatch();
  const classes = useStyles();
  const navigate = useNavigate();
  const [role, setRole] = useState('a');

  const handleCreatePerson = async (values, { resetForm }) => {
    const {name, email, password} = values;
    const userId = currentUser.uid;
    const birthdate = moment(selectedDate).format('DD/MM/YYYY');
    try {
      const user = await admin.auth().createUser({
        email,
        password,
      });
      return {
        response: user
      };
  } catch (error) {
      console.log(error);
    }
    const payload = {
      name, email, password
    };
    dispatch(Creators.createPerson(payload));
    setOpen(true);
    resetForm({});
  };

  const [open, setOpen] = useState(false);
  const [openError,] = useState(false);
  const [selectedDate, setSelectedDate] = React.useState(new Date('2014-08-18T21:11:54'));

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleStatusChange = (event) => {
    setRole(event.target.value);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <Page
      className={classes.root}
      title="Adicionar pessoas"
    >
      <Container maxWidth={false}>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          Pessoa cadastrada com sucesso!
        </Alert>
      </Snackbar>
      <Snackbar open={openError} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error">
          Erro ao cadastrar pessoa.
        </Alert>
      </Snackbar>
        <Box mt={3}>
          <Card >
            <FormContainer>
              <Formik
                initialValues={{
                  name: '',
                  email: '',
                  password: '',
                }}
                validationSchema={
                  Yup.object().shape({
                    name: Yup.string().max(255).required('Nome da pessoa é obrigatório'),
                    email: Yup.string().max(50).required('Email é obrigatório'),
                    password: Yup.string(),
                  })
                }
                onSubmit={(values, resetForm) => {
                  handleCreatePerson(values, resetForm);
                }}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  resetForm,
                  touched,
                  values
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Box sm={3}>
                      <Typography
                        color="textPrimary"
                        variant="h2"
                      >
                        Adicionar novo Colaborador
                      </Typography>
                    </Box>
                    <NumericContainer>
                      <TextField
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                        label="Nome *"
                        margin="normal"
                        name="name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.name}
                        variant="outlined"
                        fullWidth
                      />
                      <Spacing />
                      <TextField
                        fullWidth
                        label="Email"
                        margin="normal"
                        name="email"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.email}
                        variant="outlined"
                      />
                    </NumericContainer>
                    <TopSpacing />
                    <FormControl component="fieldset">
                    <FormLabel component="legend">Função</FormLabel>
                    <RadioGroup aria-label="priority" name="priority" defaultValue="a">
                      <FormControlLabel 
                        value="normal"
                        control={
                          <Radio
                            checked={role === 'normal'}
                            onChange={handleStatusChange}
                            value="normal"
                            color="primary"
                            name="radio-button-demo"
                            inputProps={{ 'aria-label': 'A' }}
                          />
                        }
                        label="Colaborador (Criação)"
                      />
                      <FormControlLabel 
                        value="manager"
                        control={
                          <Radio
                            checked={role === 'manager'}
                            onChange={handleStatusChange}
                            value="manager"
                            name="radio-button-demo"
                            inputProps={{ 'aria-label': 'B' }}
                          />
                        }
                        label="Gestor (Criação e Edição)"
                      />
                      <FormControlLabel 
                        value="admin"
                        control={
                          <Radio
                            checked={role === 'admin'}
                            onChange={handleStatusChange}
                            value="admin"
                            name="radio-button-demo"
                            color="primary"
                            inputProps={{ 'aria-label': 'C' }}
                          />
                        }
                        label="Administrador (Criação, Edição e Deleção)"
                      />
                    </RadioGroup>
                    </FormControl>
                    <TopSpacing />
                    <Divider />
                      <TextField
                        error={Boolean(touched.password && errors.password)}
                        helperText={touched.password && errors.password}
                        label="Senha *"
                        margin="normal"
                        name="password"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.password}
                        variant="outlined"
                        fullWidth
                      />
                    <TopSpacing />
                    <ButtonContainer>
                      <span>
                        <Button
                          color="primary"
                          fullWidth
                          size="large"
                          variant="outlined"
                          onClick={() => navigate('/app/pessoas')}
                        >
                          Voltar
                        </Button>
                      </span>
                      <span>
                        <Button
                          color="primary"
                          fullWidth
                          size="large"
                          type="submit"
                          variant="contained"
                        >
                          Adicionar
                        </Button>
                      </span>
                    </ButtonContainer>
                  </form>
                )}
              </Formik>
            </FormContainer>
          </Card>
        </Box>
      </Container>
    </Page>
  );
};

export default AddUserView;
